import { classNames } from "../../utils"
import { Flex, type FlexProps } from "../Flex/Flex"

export type SpaceBetweenProps = FlexProps

export function SpaceBetween({ className, ...rest }: SpaceBetweenProps) {
  return <Flex className={classNames("justify-between", className)} {...rest} />
}
